// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__238K3","visible":"Modal_visible__GbG56","wrapper":"Modal_wrapper___kpu9","close":"Modal_close__1U6uC"};